<template>
  <div>
    <!-- <section class="bg-gray-100 bg-opacity-70 p-6 m-12 px-8">
      <h2 class="font-bold text-3xl text-gray-400 mb-4">New flowers</h2>
      <el-carousel height="600px" :interval="5000">
        <el-carousel-item v-for="flower in flowers" :key="flower.id">
          <h3>{{ flower.name }}</h3>
          <img :src="flower.image" :alt="flower.name" class="" />
        </el-carousel-item>
      </el-carousel>
    </section> -->

    <section class="p-8">
      <div class="flex justify-between content-start">
        <h2 class="font-bold text-5xl text-white">Bouquets</h2>
        <button
          @click="createFlower"
          class="font-bold text-xl save bg-yellow-100 p-2 rounded-full"
        >
          + Add new
        </button>
      </div>
      <div
        class="space-x-10 font-bold text-2xl text-white flex justify-center items-center mt-10"
      >
        <router-link class="text-white inline-block" to="/flowerlist"
          >All</router-link
        >
        <router-link class="text-white inline-block" to="/flowers"
          >Only Flowers</router-link
        >

        <router-link
          class="bg-yellow-100 text-gray-500 inline-block p-2 rounded-full"
          to="/bouquet"
          >Only Bouquets</router-link
        >
      </div>

      <div class="flex grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-10">
        <!-- newf in newfs refrence newf in newfs -->
        <div
          v-for="flower in flowers"
          :key="flower.id"
          class="bg-gray-100 bg-opacity-80 shadow-md thumbnail rounded-sm"
        >
          <div class="relative">
            <div
              class="overlay absolute z-10 w-full h-full flex items-center justify-center space-x-6"
            >
              <button
                @click="removeFlower(flower.id)"
                class="remove bg-gray-700 text-white p-2 justify-center items-center font-bold"
              >
                Delete
              </button>
              <button
                @click="editFlower(flower)"
                class="bg-gray-700 text-white p-2 font-bold"
              >
                Edit
              </button>
            </div>
            <img
              class="w-full"
              :src="flower.image"
              :alt="'Image of a' + flower.name"
            />
          </div>
          <div class="p-4">
            <div class="flex justify-between items-center">
              <h2 class="font-bold">{{ flower.name }}</h2>
              <p class="font-bold">${{ flower.price }}</p>
            </div>
            <p>{{ flower.color }}</p>
          </div>
        </div>
      </div>
    </section>

    <edit-flower-modal @exit="closeModal" v-if="modal" v-model="form" />
  </div>
</template>

<script>
import { db } from "@/db";
import EditFlowerModal from "@/components/EditFlowerModal.vue";

export default {
  data: function () {
    return {
      modal: false,
      form: {},
      flowers: [],
    };
  },
  firestore: {
    flowers: db.collection("flowers").where("change", "==", true),
  },
  components: {
    EditFlowerModal,
  },
  methods: {
    // create
    createFlower() {
      this.form = {
        name: null,
        price: null,
        description: null,
        image: null,
        change: false,
      };
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },

    editFlower(flower) {
      this.form = flower;
      this.modal = true;
    },

    // delete
    removeFlower(id) {
      db.collection("flowers").doc(id).delete();
    },
  },
};
</script>
<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.save {
  color: #5b5d50;
}
.thumbnail .overlay {
  opacity: 0;
}
.thumbnail:hover .overlay {
  opacity: 1;
}
</style>